/**
 * Document GraphQL Fragments
 *
 * Complete fragment for Document primitive with all field groups:
 * - Identity & Metadata (11)
 * - Append-Only Architecture (4)
 * - Workflow Integration (2 exposed)
 * - Regulatory Evidence Linkage (2)
 * - Versioning (6 exposed)
 * - Storage (6)
 * - Chaos-to-DSL Integration (3 exposed)
 * - Creation Source (1)
 * - Status & Approval (7)
 * - Lifecycle (4 exposed)
 */

import { gql } from '@apollo/client';

export const DOCUMENT_FIELDS_FRAGMENT = gql`
  fragment DocumentFields on Document {
    # Identity & Metadata (11)
    documentId
    documentName
    documentType
    mimeType
    fileExtension
    category
    fileSizeBytes
    encoding
    description
    tags

    # Append-Only Architecture (4)
    parentVersionId
    originalId
    recordVersion
    isActive

    # Workflow Integration (2 exposed — others are graphql(skip))
    complianceFrameworks
    regulatoryDeadline

    # Regulatory Evidence Linkage (2)
    regulatoryRuleIds
    regulatoryEvidenceName

    # Versioning (6 exposed — versionCreatedBy is graphql(skip))
    version
    isLatest
    previousVersionId
    versionHistoryIds
    versionChangeDescription
    versionCreatedAt

    # Storage (6)
    storageType
    s3Bucket
    s3Key
    dynamodbContent
    externalUrl
    accessLevel

    # Chaos-to-DSL Integration (3 exposed — chaosToDslApprovedBy is graphql(skip))
    sourceChaosDocumentId
    extractionConfidence
    extractionEvidence

    # Creation Source (1) — DRR-131
    createdBySource

    # Status & Approval (7)
    currentStatus
    statusUpdatedAt
    approvalProgressJson
    validationResultsJson
    isDeleted
    generatedOffline

    # Lifecycle (4 exposed — createdBy/updatedBy are graphql(skip), use *Actor resolvers)
    createdAt
    updatedAt
    deletedAt
  }
`;

export const DOCUMENT_VERSION_INFO_FRAGMENT = gql`
  fragment DocumentVersionInfoFields on DocumentVersionInfo {
    documentId
    version
    changeDescription
    createdBy
    createdAt
    isLatest
  }
`;

export const DOCUMENT_CONNECTION_FRAGMENT = gql`
  fragment DocumentConnectionFields on DocumentConnection {
    nodes {
      ...DocumentFields
    }
    totalCount
    hasNextPage
    endCursor
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;
